import React, { useEffect, useState, useMemo, useCallback } from 'react'
import ClipLoader from "react-spinners/ClipLoader";

import { getMonthWeeks, mapEventsDays, getEventColor, getCalendarIDs, getCalendarEvents,
  ACOMODATION_1, ACOMODATION_0_COLOR, ACOMODATION_1_COLOR } from '../../utils/agenda-utis'
import { getMessages, getAccommodationSubtitle } from '../../messages/agenda-messages'
import { CASA_BANGALO } from '../../utils/available-accommodations'

const Agenda = ({ accommodation }) => {
  const [calendarLoaded, setCalendarLoaded] = useState({});
  const [rawEvents, setRawEvents] = useState([]);
  const [eventsMap, setEventsMap] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);

  const addCalendarEvents = useCallback((calendarId, events) => {
    setRawEvents(old => (old.concat(events)))
    setCalendarLoaded(old => ({...old, [calendarId]: true}));
  }, []);

  const calendarIds = useMemo(() => getCalendarIDs(accommodation), [accommodation]);

  useEffect(() => {
    calendarIds.forEach(calendar => {
      getCalendarEvents(calendar, addCalendarEvents)
    });
  }, [calendarIds, addCalendarEvents])

  useEffect(() => {
    setHasLoaded(calendarIds.every(calendar => calendarLoaded[calendar] != null));
    setEventsMap(mapEventsDays(rawEvents));
  }, [calendarLoaded, calendarIds, rawEvents])

  const [monthIndex, setMonthIndex] = useState(0);
  const [currentMonth, setCurrentMonth] = useState((new Date()).getMonth())
  const monthWeeks = getMonthWeeks(monthIndex)
  const messages = getMessages()
  const accommodations = accommodation.split('&')
  const subtitles = accommodations.map(a => getAccommodationSubtitle(a))
  const trClassName = accommodation !== CASA_BANGALO ? 'single' : 'double'

  const navNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0)
    } else {
      setCurrentMonth(currentMonth + 1)
    }
    setMonthIndex(monthIndex + 1)
  }

  const navPrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11)
    } else {
      setCurrentMonth(currentMonth - 1)
    }
    setMonthIndex(monthIndex - 1)
  }

  return (
    <section id="availability">
      <header className="major">
          <h2>{messages.title}</h2>
      </header>
      <div className="subtitle">
        {
          subtitles.map(sub => {
            const style = {
              backgroundColor: sub.color,
            }

            const textSplitted = sub.text.split(' ')

            return (
              <div className="agenda-item">
                <div style={style}/>
                <span>{textSplitted[0] + ' '}<strong>{textSplitted[1]}</strong></span>
              </div>
            )
          })
        }
      </div>
      <div className="table-wrapper">
        <div className="navigation">
          {
            monthIndex > 0
              ? <button onClick={navPrevMonth} aria-label={messages.previous}><i className="icon fa-chevron-left"/></button>
              : <button className="disabled" aria-label={messages.previous}><i className="icon fa-chevron-left"/></button>
          }

          <span><strong>{messages.months[currentMonth]}</strong></span>
          <button onClick={navNextMonth} aria-label={messages.next}><i className="icon fa-chevron-right"/></button>
        </div>
        <table className="alt">
          <div className="loader">
              <ClipLoader loading={!hasLoaded} color='#D67B27' size={70} />
          </div>
            <thead>
                <tr>
                  {
                    messages.weekdays.map(day => (<th>{day}</th>))
                  }
                </tr>
            </thead>
            <tbody>
              {
                monthWeeks.map(week => {
                  const weekContent = week.map(day => {
                    const stringDay = day.toISOString().substring(0, 10)
                    let eventsOnDay = ''

                    if (eventsMap[stringDay]) {
                      if (eventsMap[stringDay].length === 2) {
                        eventsOnDay = (
                          <>
                            <div className='reserved' style={{backgroundColor: ACOMODATION_0_COLOR}}></div>
                            <div className='reserved' style={{backgroundColor: ACOMODATION_1_COLOR}}></div>
                          </>
                        )
                      }
                      else if (accommodation === CASA_BANGALO && eventsMap[stringDay][0].includes(ACOMODATION_1)) {
                        eventsOnDay = (
                          <>
                            <div className='reserved'></div>
                            <div className='reserved' style={{backgroundColor: ACOMODATION_1_COLOR}}></div>
                          </>
                        )
                      } else {
                        eventsOnDay  = (
                          <div className='reserved' style={{backgroundColor: getEventColor(eventsMap[stringDay][0])}}></div>
                        )
                      }

                    }

                    return <td className={trClassName}><span>{day.getDate()}</span><br/>{eventsOnDay}</td>
                  })

                  return <tr>{weekContent}</tr>
                })
              }
            </tbody>
        </table>
      </div>
    </section>
  )
}

export default Agenda
